<template>
  <div>
    <Row>
      <Col :xs="24" :sm="24" :md="18" :lg="14">
        <Form
          ref="form"
          :model="forms"
          :label-width="150"
          :disabled="action == 'view' ? true : false"
        >
          <form-body
            :forms="forms"
            :items="items"
            :disabled="action == 'view' ? true : false"
          ></form-body>

          <button-box v-if="action != 'view'">
            <Poptip
              confirm
              title="请检查数据, 再确认提交"
              @on-ok="handleSubmit"
            >
              <button-sub :loading="sloading">保存</button-sub>
            </Poptip>
<!--            <button @click="handleSubmitKnow" class="knowledge">-->
<!--              保存并转存知识库-->
<!--            </button>-->
          </button-box>
        </Form>
      </Col>
    </Row>
    <Modal title="图片预览" v-model="imgVisible">
      <img :src="imgUrl" style="width: 100%" />
    </Modal>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import Change from "./question.vue";

export default {
  extends: baseEdit,
  components: {
    change: Change,
  },
  props: {
    workId: {
      type: String,
      value: "",
    },
    typeId: {
      type: String,
      value: "",
    },
    state: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "editPro",
      key: "id",
      ll: [],
      url: {
        get: "/maintainer/maintainer/work",
        // add: "/admin/system/work",
        // edit: "/admin/system/work",
      },
      items: [
        {
          label: "故障类型",
          name: "typeParentId",
          name2: "typeId",
          key: "name",
          value: "",
          value2: "",
          type: "selectTypeChild",
          disabled1:"true",
          width: "190px",
          dropList: [],
          dropList2: [],

          // desc: "如确认非硬件问题请选择关联性报修！",
          rules2: [
            {
              required: true,
              message: "故障类型不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
          onChange: this.loadChildData,
        },
        {
          label: "处理内容",
          name: "maintainerContent",
          value: "",
          dropList: [],
          type: "pullinput",
          width: "380px",
          rules: [{ required: true, trigger: "blur" }],
          onFocus: this.onTextFocus,
          onChange: this.onTextChange,
          onExtClick: this.onTextExtClick,
        },
        {
          label: "故障原因",
          name: "teackRemark",
          value: "",
          dropList: [],
          type: "select",
          width: "380px",
        },
        {
          label: "产生费用",
          name: "expensesIncurred",
          value: 0,
          type: "input",
          width: "380px",
        },
        {
          label: "维修类型",
          name: "service",
          value: "服务类",
          dropList: [
            { value: "服务类", name: "服务类" },
            { value: "换修类", name: "换修类" },
            { value: "新增类", name: "新增类" },
          ],
          type: "select",
          width: "380px",
        },
        {
          label: "处理状态",
          name: "state",
          value: 2,
          type: "select",
          width: "380px",
          dropList: [
            { value: 2, name: "维修中" },
            { value: 3, name: "完成" },
          ],
        },
        {
          label: "凭证上传",
          name: "avatar",
          value: "",
          type: "avatar",
          desc: "建议图片宽高尺寸512*512像素及以上",
          rules: [{ required: false, trigger: "blur" }],
        },
      ],
      forms: {
        repairSource: 1,
        maintainerContent: "",
        teackRemark: "",

      },
    };
  },
  created() {
    if (this.state == 3) {
      this.items[this.getItemIndex('state')].type = 'kong'
    }
    this.loadWorkCommon();
    this.loadworkData();
    this.loadTypeData()
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  methods: {
    async loadWorkCommon(){
      // 通过pk查询字典数据
      let q = {};
      q.workType = 3
      let res = await $utils.api.load("/maintainer/maintainer/common/list", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.descr;
          xx.name = element.descr;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "teackRemark") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    //选择故障类型下拉框
    async loadTypeData() {
      // 通过pk查询字典数据
      let res = await $utils.api.load(`/maintainer/maintainer/workType/parentId/${this.typeId}`);
      if (res && res.code === 200) {
        if (res.data.id == this.typeId) {
          this.loadChildData(this.typeId)
          this.forms.typeParentId = this.typeId
        }else {
          this.loadChildData(res.data.id)
          this.forms.typeParentId = res.data.id
          this.forms.typeId = this.typeId
        }
      }
    },
    //选择故障类型下拉框
    async loadworkData() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("/maintainer/maintainer/workType/typeList", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.name;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "typeParentId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    //选择故障类型下拉框
    async loadChildData(typeParentId) {
      // 通过pk查询字典数据
      let parentId = typeParentId;
      let res = await $utils.api.load(
          `/maintainer/maintainer/workType/getChildren/${parentId}`
      );
      if (res && res.data) {
        let ll = res.data;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value2 = element.id;
          xx.name2 = element.name;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name2 == "typeId") {
            this.items[index]["dropList2"] = dropList;
          }
        }
      }
    },
    handleSubmitKnow() {
      let q = this.forms;
      q.isKnow = 1;
      q.id = this.workId;

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/maintainer/maintainer/work/editWork`, q, "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(0);
                this.$Modal.remove();
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    handleSubmit() {
      let q = this.forms;
      q.isKnow = 0;
      q.id = this.workId;
      q.workId = this.workId;
      if (this.forms.state == 3) {
        q.state = 3;
        q.isFinished = 1;
      }
      if (this.forms.typeId){
        q.typeId = this.forms.typeId
      }else{
        q.typeId = this.forms.typeParentId
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/maintainer/maintainer/track`, q, "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$Modal.remove();
                $utils.url.go(0);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    onTextChange(val) {},
    onTextFocus() {},
    onTextExtClick(v) {
      let _this = this;
        this.$refs.change[0].loadData(2);
        // 按钮显示常用语
        if (this.$refs.change && this.$refs.change[0]) {
          this.$refs.change[0].open();
          this.$refs.change[0].getText2 = (val) => {
            _this.forms.maintainerContent += val + "";
          };
        }
    },
  },
};
</script>

<style lang="less">
.workcolor {
  margin: 5px 5px 5px 150px;
  width: 80px;
  height: 30px;
}

.knowledge {
  width: 125px;
  height: 30px;
  background-color: #1890ff;
  color: #f6f8f7;
  border: none;
  cursor: pointer;
}

.completecolor {
  width: 80px;
  height: 30px;
  margin: 5px 5px 5px 30px;
}
</style>
